import * as Type from './actionsTypes';

const INITIAL_STATE = {
  selectedProcedimentosNormas: {},
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.PROCEDIMENTOS_NORMAS_FIND_ONE_SUCCESS:
    case Type.PROCEDIMENTOS_NORMAS_UPDATE_SUCCESS:
    case Type.PROCEDIMENTOS_NORMAS_CREATE_SUCCESS: {
      return { ...state, selectedProcedimentosNormas: action.data }
    }
    case Type.PROCEDIMENTOS_NORMAS_CLEAR_SELECTED: {
      return { ...state, selectedProcedimentosNormas: {} }
    }
    case Type.PROCEDIMENTOS_NORMAS_CLEAN: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}

export const getSelectedProcedimentosNormas = state => state.rootState.procedimentosNormas.selectedProcedimentosNormas;
